import $ from "jquery";
import React from "react";

import Carousel from "./nounproject-carousel";

class BlogCarousel extends React.Component {
    componentWillMount() {
        this.fetchBlogs();
    }

    constructor(props) {
        super(props);

        this.state = {
            blogs: []
        };
    }

    fetchBlogs() {
        $.ajax({
            url: "/homepage/blog/",
            type: "GET",
            success: (_this => (data, status, xhr) => {
                let blogPosts = [];

                Object.values(data).forEach(blog => {
                    // remove blogs that don't have images
                    if (blog.virtuals.previewImage.imageId) {
                        blogPosts.push(blog);
                    }
                });

                if (blogPosts.length % 2 !== 0) {
                    // if there are an odd number of blogs remove the last blog from the list
                    blogPosts.pop();
                }

                this.setState({
                    blogs: blogPosts
                });
            })(this)
        });
    }

    render() {
        if (this.state.blogs.length > 0) {
            let carouselItems = this.renderCarouselItems();

            return (
                <div className="blog-carousel margin-t-xxl padding-t-xl padding-b-xl">
                    <style>
                        {`
                    .blog-carousel {
                        background-color: #1F1F1F;
                    }

                    .blog-carousel .blog-list-item {
                        background-color: white;
                        min-height: 300px;
                        position: relative;
                        overflow: hidden;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center center;
                    }
                    .blog-list-item-name{
                        max-width: 90%;
                    }
                    .blog-carousel .blog-list-item .text-container{
                      width: 100%;
                      background: rgba(255,255,255,0.75);
                      text-align: left;
                      padding: 24px;
                      position: absolute;
                      bottom: 0;
                      color: #000000;
                    }
                    .blog-carousel .fake-link{
                        display: block;
                        position:absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border: 0;
                        transition: all 0.3s ease-out;
                        border: solid 3px #ffffff;
                    }

                    .blog-carousel .carousel-item {
                        margin: 0 auto;
                    }
                    .blog-carousel h1{
                        color: #FFFFFF;
                    }
                    @media (min-width: 960px) {
                        .blog-carousel .carousel-item {
                            margin: inherit;
                            max-width: 479px;
                            margin: 0;
                        }
                        .blog-carousel .blog-list-item .text-container{
                            bottom: -100px;
                            opacity: 0;
                            transition: all 0.3s ease-out
                        }
                        .blog-carousel .fake-link{
                            border: none;
                        }
                        .blog-carousel .fake-link:hover{
                            border: solid 3px #ffffff;
                        }
                        .blog-carousel .blog-list-item:hover .text-container{
                            opacity: 1;
                            bottom: 0;
                        }
                        .blog-carousel h1{
                            color: #FFFFFF;
                        }
                    }
                `}
                    </style>
                    <div className="padding-b-l">
                        <div className="container row">
                            <h1 className="col-xs-12 font-xlarge">
                                Recent Posts
                            </h1>
                        </div>
                        <div className="container">
                            <Carousel items={carouselItems} itemsPerView={2} />
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderCarouselItems() {
        let carouselItems = [];

        // carousel item html is rendered in the parent template to customize output
        this.state.blogs.forEach(blog => {
            let imageUrl =
                    "https://cdn-images-1.medium.com/max/1000/" +
                    blog.virtuals.previewImage.imageId,
                title = blog.title.replace(/\s(?=\S*$)/g, "\u00a0");

            carouselItems.push(
                <div
                    key={blog.id}
                    className="carousel-item col-lg-6 col-sm-6 col-xs-12"
                >
                    <div
                        className="blog-list-item"
                        style={{
                            backgroundImage: `url("${imageUrl}")`
                        }}
                    >
                        <a
                            className="fake-link"
                            href={`//blog.thenounproject.com/${
                                blog.uniqueSlug
                            }`}
                            target="_blank"
                        >
                            <div className="text-container">
                                <h3 className="blog-list-item-name font-medium">
                                    {title}
                                </h3>
                                <span className="text-link">Read on</span>
                            </div>
                        </a>
                    </div>
                </div>
            );
        });

        return carouselItems;
    }
}

module.exports = BlogCarousel;
